import React from 'react';
import querystring from 'querystring';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop } from 'components/Panel';
import PlayerLink from 'components/PlayerLink';
import { Table, Th, Td } from 'components/Table';

export default class DoubleActsPage extends React.Component {
    componentDidMount() {
        if (window !== undefined) {
            window.addEventListener('popstate', event => {
                let params = {};
                if (window.location.search) {
                    params = querystring.parse(window.location.search.substring(1));
                }
                this.props.browserBack(window.location.pathname, params);
            });
        }
    }

    render() {
        const { entries, sort, sortColumn } = this.props;
        return (
            <Main>
                <MainHeader />
                <Body id="double-acts-page">
                    <Panel border>
                        <PanelTop title="Double Acts" buttons />
                        <DoubleActsTable entries={entries} sort={sort} sortColumn={sortColumn} />
                    </Panel>
                </Body>
            </Main>
        );
    }
}

const DoubleActsTable = ({ entries, sort, sortColumn }) => (
    <Table striped hover>
        <thead>
            <tr>
                <Th min="8" />
                <Th left>Bowler</Th>
                <Th left>Fielder</Th>
                <Th sortable min="2" short="2" value="Vics" id="victims" sort={sort} onSort={sortColumn}>
                    Victims
                </Th>
                <Th sortable priority="2" id="caught" sort={sort} onSort={sortColumn}>
                    Caught
                </Th>
                <Th sortable priority="2" id="stumped" sort={sort} onSort={sortColumn}>
                    Stumped
                </Th>
            </tr>
        </thead>
        <tbody>{entries.map((row, index) => <DoubleActRow key={index} index={index} row={row} />)}</tbody>
    </Table>
);

const DoubleActRow = ({ row, index }) => (
    <tr>
        <Td min="8">{index + 1}</Td>
        <Td left>
            <PlayerLink pid={row.bowler_pid} fname={row.bowler_fname} lname={row.bowler_lname} />
        </Td>
        <Td left>
            <PlayerLink pid={row.fielder_pid} fname={row.fielder_fname} lname={row.fielder_lname} />
        </Td>
        <Td sortable min="2">
            {row.victims}
        </Td>
        <Td sortable priority="2">
            {row.caught}
        </Td>
        <Td sortable priority="2">
            {row.stumped}
        </Td>
    </tr>
);



// WEBPACK FOOTER //
// ./src/views/double-acts/DoubleActsPage.jsx